import React from "react";
import { Highlighter, StickyNote } from "lucide-react";
import {
  getAnimationSectionId,
  sectionHasTextContent,
} from "./noteUtils";
import "./LessonNotes.css";

export default function HighlightableSection({
  section,
  sectionNumber,
  index,
  note,
  isDarkMode,
  onToggleHighlight,
  onOpenNote,
  children,
}) {
  const animationSectionId = getAnimationSectionId(
    section,
    sectionNumber,
    index
  );
  const hasNote = !!(note?.note && String(note.note).trim());
  const highlighted = !!note && !hasNote;
  const hasText = sectionHasTextContent(section);

  return (
    <div
      id={`section-${animationSectionId}`}
      className={`highlightable-section${
        note ? " is-highlighted" : ""
      } ${isDarkMode ? "dark" : "light"}`}
    >
      <div className="highlightable-section-actions">
        {hasText && !hasNote && (
          <button
            type="button"
            className={highlighted ? "active" : ""}
            aria-label={highlighted ? "Remove highlight" : "Highlight section"}
            onClick={(event) => {
              event.stopPropagation();
              onToggleHighlight(animationSectionId);
            }}
          >
            <Highlighter size={13} strokeWidth={1.75} />
          </button>
        )}
        <button
          type="button"
          className={hasNote ? "active" : ""}
          aria-label={hasNote ? "Edit note" : "Add note"}
          onClick={(event) => {
            event.stopPropagation();
            onOpenNote(animationSectionId, note?.note || "");
          }}
        >
          <StickyNote size={13} strokeWidth={1.75} />
        </button>
      </div>
      {children}
    </div>
  );
}
